__turbopack_context__.v({
  "breadcrumbWrapper": "FolderBreadcrumbs-module__FxsoKq__breadcrumbWrapper",
});
